import { Button, Select, InputNumber, Form, Input, Modal, Space, Alert, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { editAssignment, toggleModal } from "../../../features/assignments/assignmentsSlice";
import { useEffect } from "react";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import { useAddAssignmentMutation, useEditAssignmentMutation, useGetAssignmentsQuery } from "../../../features/assignments/assignmentsApi";

export default function AssignmentForm() {
  const dispatch = useDispatch()
  const [form] = Form.useForm();

  const { data: videos } = useGetVideosQuery()
  const { openModal, assignment } = useSelector(state => state.assignments)

  const { data: assignements } = useGetAssignmentsQuery()
  const [addAssignment, { isLoading, isError, error, data }] = useAddAssignmentMutation();
  const [updateAssignment, { isLoading: isUpdating, isError: updateIsError, error: updateError, data: updatedData }] = useEditAssignmentMutation();

  const submitHandler = (data) => {
    // TODO 
    // A video cannot have multiple assignements 

    const video_title = videos?.find(v => v?.id == data?.video_id)?.title || '';
    if (!video_title) {
      message.error('Internal server error!!!')
      return;
    };
    try {
      if (assignment && assignment?.id) {
        //update assignment
        // check for unique video selection
        if (assignements?.length) {
          const isExist = assignements.find(a => a.video_id == data?.video_id && assignment.video_id !== data?.video_id)
          if (isExist) {
            message.error('The video you selected is already have assignment!')
            return;
          }
        }
        updateAssignment({ id: assignment?.id, data: { ...data, video_title } })
      } else {
        //add assignment
        if (assignements?.length) {
          const isExist = assignements.find(a => a.video_id == data?.video_id)
          if (isExist) {
            message.error('The video you selected is already have assignment!')
            return;
          }
        }
        const createdAt = new Date().toISOString()
        addAssignment({ ...data, createdAt, video_title })
      }
      cancelHandler()

    } catch (error) {

    }
  }

  const cancelHandler = () => {
    dispatch(toggleModal(false))
    form.resetFields()
    dispatch(editAssignment({}))
  }

  useEffect(() => {
    if (assignment && Object.entries(assignment).length) {
      form.setFieldsValue({ ...assignment })
    } else {
      form.resetFields()
    }
  }, [assignment, form])

  const title = assignment && assignment?.id ? 'Update Assignment' : 'Add New Assignment';

  return (
    <Modal open={openModal} title={title}
      centered
      footer={false}
      onCancel={cancelHandler}>
      {
        !videos?.length ?
          <Alert type="error" message="Error" description="No Videos Found! Please add a video first!" />
          :

          <Form onFinish={submitHandler} form={form} layout="vertical">
            <Form.Item label="Title" name="title" rules={[{ required: true, message: 'Title is required' }]}>
              <Input />
            </Form.Item>
            <Form.Item label="Select Video" name="video_id" rules={[{ required: true, message: 'Select a video' }]}>
              <Select
                options={videos}
                fieldNames={{ label: 'title', value: 'id' }}
              />
            </Form.Item>
            <Form.Item label="Total Mark" name="totalMark" rules={[{ required: true, message: 'Total mark is required' }]}>
              <InputNumber className="w-full" type="number" min={1} />
            </Form.Item>

            <Form.Item className="flex justify-end">
              <Space>
                <Button onClick={cancelHandler}>Cancel</Button>
                <Button type="primary" htmlType="submit">Submit</Button>
              </Space>
            </Form.Item>
          </Form>
      }
    </Modal>
  )
}